import Vue from 'vue'
import Vuex from 'vuex'
import ky from '@/network';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    session: null,
    products: [],
    categories: [],
    cart: [],
    settings: {},
    incompleteReservations: [],
    upcomingReservations: [],
    shopInfo: {},
    storeGallery: [],
    documents: []
  },
  mutations: {
    setInfo(state,s){
      state.shopInfo = s;
      document.title = state.shopInfo.name + " | Menu al Volo" ;
    },
    setSession(state,s){
      state.session = s;
    },
    setProducts(state,p){
      state.products = p;
    },
    setCategories(state,c){
      state.categories = c;
    },
    setCart(state,c){
      state.cart = c;
    },
    setSettings(state,c){
      state.settings = c;
    },
    setIncompleteReservations(state,c){
      state.incompleteReservations = c;
    },
    setUpcomingReservations(state,c){
      state.upcomingReservations = c;
    },
    setStoreGallery(state,c){
      state.storeGallery = c;
    },
    setDocuments(state,d){
      state.documents = d;
    }
  },
  actions: {
    async getShopInfo({commit}){
      let p = (await ky.get("./api/ShopInformation").json());
      commit("setInfo",p.info);
    },
    async getSession({commit}){
      let s = (await ky.get("./api/Session").json()).session;
      commit("setSession",s);
    },
    async getProducts( {commit}){
      let p = (await ky.get("./api/Product").json());
      commit("setProducts",p.products);
    },
    async getCategories({commit}){
      let c = (await ky.get("./api/Category").json());
      commit("setCategories",c.products);
    },
    async getCart({commit}){
      let c = (await ky.get("./api/Order/Cart").json());
      commit("setCart",c.cart);
    },
    async addToCart({dispatch},payload){
      await ky.post("./api/Order/Cart/Add",{json: payload}).json();
      await dispatch('getCart');
    },
    async deleteCart({dispatch},id){
      await ky.delete("./api/Order/Cart/Delete",{searchParams: {id}}).json();
      await dispatch('getCart');
    },
    async changeCartQuantity({dispatch},payload){
      await ky.post("./api/Order/Cart/SetQuantity",{searchParams: payload}).json();
      await dispatch('getCart');
    },
    async getSettings({commit}){
      let p = (await ky.get("./api/Settings").json());
      commit("setSettings",p.settings);
    },
    // eslint-disable-next-line no-unused-vars
    async createReservation({dispatch},payload){
      return (await ky.post("./api/Reservation",{json: payload}).json())
    },
    async getIncompleteReservations({commit}){
      let r = await ky.get("./api/Reservation/Incomplete").json();
      commit("setIncompleteReservations",r.reservations);
    },
    async getUpcomingReservations({commit}){
      let r = await ky.get("./api/Reservation/Upcoming").json();
      commit("setUpcomingReservations",r.reservations);
    },
    async setReservationStatus({dispatch},payload){
      await ky.post("./api/Reservation/Status",{json: payload}).json();
      dispatch("getIncompleteReservations");
      dispatch("getUpcomingReservations");
    },
    // eslint-disable-next-line no-unused-vars
    async loginWithActionToken({dispatch},actionToken){
      let r = await ky.post("./api/Reservation/SetActionToken",{searchParams: {actionToken}});
      return r;
    },
    async setTable({dispatch},tableId){
      await ky.post("./api/Order/SetTable",{searchParams: {id: tableId}});
      dispatch("getSession")
    },
    async confirmCart({dispatch}){
      await ky.post("./api/Order/Cart/Confirm");
      await dispatch('getCart');
    },
    async getStoreGallery({commit}){
      let g = await ky.get("./api/Image/Images?context=store").json();
      commit("setStoreGallery",g.images);
    },
    async getDocuments({commit}){
      var d = await ky.get("./api/Documents").json()
      commit("setDocuments",d.documents);
    },
  },
  modules: {
  },
  getters: {
    user: state => state.session.user,
    categories: state => {
      return state.categories;
    },
    enableCheckout: (state) => {
      if(!state.settings.menu) return false;
      return state.settings.menu.enableCheckout && (!state.settings.menu.forceTableCheckout || (state.session.fields && state.session.fields.menu && state.session.fields.menu.table))
    }
  }
})
